/**
 * Formats a number as a professional AED currency string with commas.
 * e.g. 787126.5 → "AED 787,126.50"
 */
export const formatCurrency = (amount, showPrefix = true) => {
    const formatted = Number(amount || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return showPrefix ? `AED ${formatted}` : formatted;
};

/**
 * Formats a plain number with commas (no currency prefix).
 * e.g. 1234567 → "1,234,567"
 */
export const formatNumber = (num) =>
    Number(num || 0).toLocaleString('en-US');

export default formatCurrency;
